"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var WindowPerformanceRowsDataDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowPerformanceRowsDataDTO, _DomainObject_1$Domai);

  /**
   * @param rows
   * @param totalRowCount
   * @param expandedGroups
   */
  function WindowPerformanceRowsDataDTO(rows, totalRowCount, expandedGroups) {
    var _this;

    _classCallCheck(this, WindowPerformanceRowsDataDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowPerformanceRowsDataDTO).call(this));
    _this.rows = rows;
    _this.totalRowCount = totalRowCount;
    _this.expandedGroups = expandedGroups;
    return _this;
  }

  return WindowPerformanceRowsDataDTO;
}(DomainObject_1.DomainObject);

exports.WindowPerformanceRowsDataDTO = WindowPerformanceRowsDataDTO;